import { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { ApiStatusTypeEnum } from "../../../../enumeration/ApiStatusTypeEnum";
import { useAuth } from "../../../auth/components/AuthInit";
import { getCookie } from "../../../slidebar/components/DarkMode";
import * as actions from "../../redux/PromotionAction";
import { PromotionCaptionForm } from "./PromotionCaptionForm";

export const PromotionCaptionDialog = ({
  setShow,
  show,
  promotionId,
  setSwalProps,
  setPromotionId,
}) => {
  const intl = useIntl();
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const isResetField = useRef(true);

  const handleClose = () => {
    setShow(false);
    setPromotionId(undefined);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const saveValues = (queryParams) => {
    const imagename = queryParams.image
      ? `${Date.now()}.${queryParams.image.name.split(".").at(-1)}`
      : "";

    const newQueryParams = {
      action: "updateinsertpromocaption",
      agentid: auth.selagentid ?? auth.agentid,
      loginid: auth.selloginid ?? auth.loginid,
      projectid: auth.selprojectid ?? auth.projectid,
      promotionid: promotionId,
      imagename: imagename,
      ...queryParams,
      image: undefined,
    };

    const formData = new FormData();
    formData.append("imagename", imagename);
    formData.append("image", queryParams.image);
    formData.append("jsonData", JSON.stringify(newQueryParams));

    dispatch(actions.manageCaption(formData)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        isResetField.current = false;
        dispatch(
          actions.fetchPromotionCaptionList({ promotionid: promotionId })
        );
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({
            id: "updateSuccessfully",
          }),
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "caption",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PromotionCaptionForm
            formikRef={formikRef}
            promotionId={promotionId}
            saveValues={saveValues}
            fileInputRef={fileInputRef}
            isResetField={isResetField}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "saveChanges" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
